import { giphyBlack } from '@giphy/colors'
import { useMemo } from 'react'
import { IconComponent, SegmentedControl } from 'ui'
import Align, { alignOptions, iconFromAlignOption, labelFromAlignOption } from '../../../../../types/align'
import { Subheading } from '../../style'
import { SquareButton, TooltipContent } from './style'

const ALIGN_LABELS = alignOptions.map(labelFromAlignOption)

type Props = {
    align?: Align
    buttonColor?: string
    className?: string
    onChange?: (align: Align) => void
}

const UGECaptionsEditorAlign = ({ align, buttonColor = giphyBlack, className, onChange }: Props) => {
    const activeIndex = useMemo(() => (align ? alignOptions.indexOf(align) : -1), [align])

    const icon = useMemo(() => {
        if (activeIndex < 0) {
            return
        }

        return iconFromAlignOption(alignOptions[activeIndex])
    }, [activeIndex])

    const onAlignChange = (index: number) => {
        onChange?.(alignOptions[index])
    }

    return (
        <SquareButton
            className={className}
            dropdownOptions={{ width: 420 }}
            iconButtonOptions={{ color: buttonColor }}
            label={icon ? <IconComponent height={24} icon={icon} width={24} /> : undefined}
            labelStyle={{ padding: 0 }}
        >
            <TooltipContent>
                <Subheading>Text Align</Subheading>
                <SegmentedControl defaultIndex={activeIndex} options={ALIGN_LABELS} onChange={onAlignChange} />
            </TooltipContent>
        </SquareButton>
    )
}

export default UGECaptionsEditorAlign
